<svg width="30" height="29" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M28.1981 14.5954C28.1981 21.9362 22.2472 27.887 14.9064 27.887C7.56563 27.887 1.61475 21.9362 1.61475 14.5954C1.61475 7.25459 7.56563 1.30371 14.9064 1.30371C22.2472 1.30371 28.1981 7.25459 28.1981 14.5954Z"
    fill="#00B7FF"
    stroke="#007AFF"
    stroke-width="2" />
</svg>
